<template>
    <!--Wrapper - Outer-->
    <div class="wrapper outer">
        <div class="wrapper inner">
            <!--Sidebar - Primary-->

            <div class="sidebar primary" id="dvSidebarPrimary">
                <!--Header Section-->

                <PrimarySidebar />
            </div>

            <!--Page-->

            <div class="page">
                <!--Content-->

                <div class="content">
                    <!--Modal - Modal Command - Primary - Plano De Aula-->

                    <ModalUser />

                    

                    <!--Modal - Modal Search - Primary-->

                  
                    <!--Tela Principal-->

                    <div class="tela-principal">
                        <div
                            class="page-wrapper primary"
                            id="dvPageWrapperPrimary"
                        >
                            <!--Page Body - Primary-->

                            <section class="section page-body primary special">
                                <div class="page-body-wrapper primary">
                                    <!--Navbar - Primary-->

                                    <Toolbar />

                                    <!--Wizard-->

                                    <div class="wizard">
                                        <!--Command List - Primary-->

                                        <section
                                            class="section command-list primary"
                                        >
                                                  
                                        <section class="section message-list primary" ref="chatContainer">

                                            <!--Content Section-->

                                            <div class="message-list-content">
                                                <div class="content-wrapper primary">
                                                    <div class="wrapper-inner asking">
                                                        <div class="content-text">
                                                            <div class="desc">
                                                                <p v-if="currentRunIa && currentRunIa.parameters">
                                                                    <template v-for="param in currentRunIa.parameters" :key="param.property">
                                                                        {{ param.property.charAt(0).toUpperCase() + param.property.slice(1).replace(/_/g, ' ') }}: {{ param.value }}.<br><br>
                                                                    </template>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="wrapper-inner answer">
                                                        <div class="content-icon">
                                                            <div class="icon">
                                                                <img src="assets/images/logo/logo-escolarai-b.svg" />
                                                            </div>
                                                        </div>
                                                        <div class="content-value">
                                                            <div class="value-text">
                                                                <div class="title">
                                                                    <h3>
                                                                        {{ currentCrew.name }}
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div class="value-caption">

                                                            </div>
                                                            <div class="value-text" v-html="responseRunIa?.output">
                                                             
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="message-list-content" v-for="(message, index) in chatMessages" :key="index">
                                                <div class="content-wrapper primary">
                                                    <div class="wrapper-inner asking">
                                                        <div class="content-text">
                                                            <div class="desc">
                                                                <p>
                                                                  {{ message }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="wrapper-inner answer">
                                                        <div class="content-icon">
                                                            <div class="icon">
                                                                <img src="assets/images/logo/logo-escolarai-b.svg" />
                                                            </div>
                                                        </div>
                                                        <div class="content-value">
                                                            <div class="value-text">
                                                                <div class="title">
                                                                    <h3>
                                                                       {{ currentCrew.name }}
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            <div class="value-text" v-html="replyMessages[index]">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="loading-dots" v-if="showLoading">
                                                <div class="loading-dots-content">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </div>
                                            </div>
                                        </section>

                                            <!--Footer Section-->

                                          
                                        </section>
                                    </div>
                                </div>
                            </section>

                          

                            <section class="section message-box primary">
                                <!--Content Section-->

                                <div class="message-box-content">
                                    <div class="content-form">
                                        <div class="form-group">
                                            <div class="form-input">
                                                <span class="link">
                                                    <a
                                                        class="link-form"
                                                        @click="setFavoriteRunIa"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M12.2963 2.29489C12.3402 2.20635 12.4079 2.13183 12.4918 2.07972C12.5757 2.02761 12.6725 2 12.7713 2C12.8701 2 12.9669 2.02761 13.0509 2.07972C13.1348 2.13183 13.2025 2.20635 13.2463 2.29489L15.5563 6.97389C15.7085 7.28186 15.9331 7.5483 16.211 7.75035C16.4888 7.95239 16.8115 8.08401 17.1513 8.13389L22.3173 8.88989C22.4152 8.90408 22.5072 8.94537 22.5828 9.00909C22.6585 9.07282 22.7148 9.15644 22.7453 9.2505C22.7759 9.34456 22.7796 9.4453 22.7559 9.54133C22.7322 9.63736 22.6821 9.72485 22.6113 9.79389L18.8753 13.4319C18.6289 13.672 18.4446 13.9684 18.3382 14.2955C18.2317 14.6227 18.2064 14.9708 18.2643 15.3099L19.1463 20.4499C19.1636 20.5477 19.153 20.6485 19.1158 20.7406C19.0786 20.8327 19.0163 20.9125 18.9359 20.9709C18.8555 21.0293 18.7603 21.0639 18.6612 21.0708C18.5621 21.0777 18.463 21.0566 18.3753 21.0099L13.7573 18.5819C13.453 18.4221 13.1145 18.3386 12.7708 18.3386C12.4272 18.3386 12.0886 18.4221 11.7843 18.5819L7.16733 21.0099C7.07966 21.0563 6.98073 21.0772 6.88178 21.0701C6.78284 21.0631 6.68785 21.0285 6.60763 20.9701C6.5274 20.9118 6.46516 20.8321 6.42799 20.7401C6.39081 20.6481 6.38019 20.5476 6.39733 20.4499L7.27833 15.3109C7.33653 14.9716 7.31131 14.6233 7.20487 14.2959C7.09842 13.9686 6.91394 13.672 6.66733 13.4319L2.93133 9.79489C2.85992 9.72593 2.80932 9.63829 2.78529 9.54197C2.76126 9.44565 2.76477 9.34451 2.79541 9.25008C2.82605 9.15566 2.8826 9.07174 2.95861 9.00788C3.03462 8.94402 3.12703 8.90279 3.22533 8.88889L8.39033 8.13389C8.73059 8.08439 9.05372 7.95295 9.33191 7.75088C9.61011 7.54881 9.83503 7.28216 9.98733 6.97389L12.2963 2.29489Z"
                                                                stroke="#FFFFFF"
                                                                stroke-width="2"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </a>
                                                </span>
                                                <span class="input">
                                                    <input
                                                        type="search"
                                                        v-model="hasMessage"
                                                        class="form-control"
                                                        placeholder="Escreva a tarefa que precisa ser feita"
                                                        @keyup.enter="getReplyRunIa"
                                                    />
                                                </span>
                                                <span class="button">
                                                    <button
                                                        type="button"
                                                        class="btn btn-block btn-form"
                                                        @click="getReplyRunIa"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                fill-rule="evenodd"
                                                                clip-rule="evenodd"
                                                                d="M4.79495 5.12264C3.06804 4.50448 1.48934 6.34298 2.36147 7.95659L4.91684 12.6845L2.45796 16.9331C1.53522 18.5274 3.07596 20.4157 4.82302 19.8317L20.5763 14.5658C22.3773 13.9637 22.4041 11.4259 20.6163 10.7859L4.79495 5.12264ZM17.2389 11.7012L4.12092 7.00564L6.65881 11.7012H17.2389ZM6.63923 13.7012L4.18895 17.9349L16.854 13.7012H6.63923Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="content-caption">
                                        <div class="caption">
                                            <span>
                                                Lembre-se de sempre revisar! Os
                                                textos são gerados por
                                                inteligência artificial e podem
                                                conter informações imprecisas.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PrimarySidebar from '@/components/primarySidebar.vue';
    import parameters from '@/utils/parameters.js';
    import { mapState, mapActions } from 'vuex';
    import ModalUser from '@/components/modals/modalUser.vue';
    import order from '@/utils/order';
    import Toolbar from '@/components/toolbarHeader.vue';
    import { toast} from 'vue3-toastify';


    export default {
        components: {
            PrimarySidebar,
            ModalUser,
            Toolbar
        },
        data() {
            return {
                hasMessage: '',
                menssageCrew: '',
                crews: [],
                userData: {
                    name: '',
                    email: '',
                    password: ''
                },
                parameters: [],
                responseRunIa: [],
                chatMessages: [],
                replyMessages: [],
                showLoading: false
            };
        },
        computed: {
            ...mapState(['token', 'user', 'currentCrew', 'currentRunIa', 'userInfoData'])
        },
        mounted() {
            this.getResponseRunIa();
        },
        updated() {
            this.scrollToBottom();
        },
        methods: {
            ...mapActions(['getCrews', 'storeIsVisibleSideBarGenericModal', 'storeFieldsModalGeneric', 'storeCurrentCrew', 'storeUserInfoData', 'storeIsVisibleModalUser', 'storeCrewsList']),
            async getParameters(id, crew) {
                try {
                    const response = await parameters.getParameters(this.token, id);
                    this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: true });
                    this.storeFieldsModalGeneric({ fields: response });
                    this.storeCurrentCrew({ currentCrew: crew });
                    this.parameters = response;
                } catch (error) {
                    console.error('Erro ao buscar parâmetros:', error);
                }
            },
            notify(text) {
                const message = text.title + " favoritada com sucesso.";
                toast(message, {
                        autoClose: 3000,
                        position: 'top-right',
                        theme: "light",
                        type: "success",
                        dangerouslyHTMLString: true
                    });
            },
            async getResponseRunIa() {
                this.showLoading = true;
                const payload = {
                    "id": this.currentRunIa?.id || 0,
                    "type_engine": this.currentRunIa?.type_engine || 1,
                    "crew_id": this.currentRunIa?.crew_id || this.currentCrew.id,
                    "request_type": this.currentRunIa?.request_type || 1,
                    "status": this.currentRunIa?.status || 0,
                    "parameters": this.currentRunIa?.parameters || []
                };
                try {
                    const response = await order.order(payload, this.token);
                    if (response?.output) {
                        response.output = response.output
                            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                            .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                            .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                            .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                            .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                            .replace(/\*(.*?)\*/g, '<em>$1</em>')
                            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                            .replace(/`([^`]+)`/g, '<code>$1</code>')
                            .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                            .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                            .replace(/^- (.*$)/gm, '<li>$1</li>')
                            .replace(/\n/g, '<br> ');
                    }
                    console.log(response.output);
                    this.responseRunIa = response;
                    this.showLoading = false;
                    console.log(response);
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            async getReplyRunIa() {
                if (!this.hasMessage) return;
                
                this.showLoading = true;
                this.chatMessages.push(this.hasMessage);
                const message = this.hasMessage;
                this.hasMessage = '';

                const payload = {
                    "id": this.responseRunIa.id,
                    "type_engine": 1,
                    "crew_id": this.currentCrew.id,
                    "request_type": 1,
                    "status": 0,
                    "parameters": [
                        {
                            "type": 1,
                            "property": "request",
                            "value": message
                        }
                    ]
                };

                try {
                    const response = await order.order(payload, this.token);
                    if (response?.output) {
                        response.output = response.output
                            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                            .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                            .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                            .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                            .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                            .replace(/\*(.*?)\*/g, '<em>$1</em>')
                            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                            .replace(/`([^`]+)`/g, '<code>$1</code>')
                            .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                            .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                            .replace(/^- (.*$)/gm, '<li>$1</li>')
                            .replace(/\n/g, '<br> ');
                    }
                    this.replyMessages.push(response?.output ?? '');
                    this.showLoading = false;
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            scrollToBottom() {
                const container = this.$refs.chatContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            },
            async setFavoriteRunIa() {
                const payload = {
                    "id":  this.responseRunIa.id
                };
                try {
                    const response = await order.setOrderFavorite(payload, this.token);
                    console.log(response);
                    this.notify(response);
                } catch (error) {
                    console.error('Erro ao favoritar conversa:', error);
                }
            }
        }
    };
</script>

<style lang="scss" scoped></style>
<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: #4FCCEA;
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

.value-text p {
    color: white;
}

.section.message-list {
    height: calc(100vh - 200px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.section.message-list::-webkit-scrollbar {
    width: 8px;
}

.section.message-list::-webkit-scrollbar-track {
    background: transparent;
}

.section.message-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.section.message-list::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.value-text {
    color: #e8e8e8;
}
</style>